import { manageAppointmentsActionTypes } from "../constants/ApiConstants";

const initialState = {
  loading: false,
  appointmentList: null,
  saved_appointmentList: null,
  master_data: [],
  cancelledAppointment: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case manageAppointmentsActionTypes.get_patient_appointment_list.REQUEST:
      return {
        ...state,
        loading: true,
        appointmentList: null
      };
    case manageAppointmentsActionTypes.get_patient_appointment_list.SUCCESS:
      return {
        ...state,
        loading: false,
        appointmentList: payload
      };
    case manageAppointmentsActionTypes.save_encounter_with_signature.REQUEST:
      return {
        ...state,
        loading: true,
        saved_appointmentList: null
      };
    case manageAppointmentsActionTypes.save_encounter_with_signature.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_appointmentList: payload
      };
    case manageAppointmentsActionTypes.get_masterdata.REQUEST:
      return {
        ...state,
        loading: true      
      };
    case manageAppointmentsActionTypes.get_masterdata.SUCCESS:
      return {
        ...state,
        loading: false,
        master_data: payload,
      };
    case manageAppointmentsActionTypes.cancel_appointment.REQUEST:
      return {
        ...state,
        loading: true,
        cancelledAppointment: null,
      };
    case manageAppointmentsActionTypes.cancel_appointment.SUCCESS:
      return {
        ...state,
        loading: false,
        cancelledAppointment: payload,
      };
      default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/ManageAppointments/components/appointments/reducers/manageAppointmentReducer.js